import React from 'react';
import { ReactQueryDevtools } from 'react-query-devtools';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import { defaultQueryConfig } from '../config';
import { EApiProvider } from '../context/EApi';
import { StoreProvider } from '../context/Store';
import { CheckoutProvider } from '../context/Checkout';
import CartPortal from './CartIcon/CartIconPortal';
import ShopNavPortal from './ShopNav/ShopNav';
import { jsx as ___EmotionJSX } from "@emotion/react";
const queryCache = new QueryCache(defaultQueryConfig);
const Root = _ref => {
  let {
    children
  } = _ref;
  return ___EmotionJSX(StoreProvider, null, ___EmotionJSX(EApiProvider, null, ___EmotionJSX(CheckoutProvider, null, ___EmotionJSX(ReactQueryCacheProvider, {
    queryCache: queryCache
  }, ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ReactQueryDevtools, null), ___EmotionJSX(CartPortal, null), ___EmotionJSX(ShopNavPortal, null), children)))));
};
export default Root;